/**
 * Main entry point for @tableau/animation module
 *
 * This is where we re-export everything that should be publicly available.
 * The build system expects this file to match the globalVarName: 'Animation'
 */

export { Animation } from './BaseAnimation';
export { IAnimationUserData } from './IAnimationUserData';
export { AnimationManager } from './AnimationManager';
export { AnimationPlayStyle } from './AnimationPlayStyle';
export { AnimationPlayInfo, AnimationCompletionFunc } from './AnimationPlayInfo';
export { ScalarAnimation } from './ScalarAnimation';
export { IntAnimation, IntRef } from './IntAnimation';
export { ScalarLinearKeyframeAnimation, Keyframe } from './ScalarLinearKeyframeAnimation';
export { IntStepAnimation, IntKeyframe } from './IntStepAnimation';
export { KeyframeFractionUtils, KeyframeBase } from './KeyframeFractionUtils';
export { AnimationGroup } from './AnimationGroup';
export { AnimationsInParallel, PostUpdatesFunc, PaneStatePostUpdateFunc, IPaneState } from './AnimationsInParallel';
export { AnimationsInSequence } from './AnimationsInSequence';
export { FractionWarperAnimation } from './FractionWarperAnimation';
export { FractionWarperTiming } from './FractionWarperTiming';
export { WarpingFunction, WarpingFunctionMapUtil, FractionWarperCurve } from './WarpingFunctionMapUtil';
export { IDataStore, DataStore } from './IDataStore';
export { PaneStateAttribute, PaneStateAttributeUtil } from './PaneStateAttribute';
export { HuttParser } from './HuttParser';
export { DataStorePaneState } from './DataStorePaneState';
export { PaneStateAnimation, PaneStateUpdateCallback } from './PaneStateAnimation';
export { MarkAnimationController, tick } from './MarkAnimationController';
export { DataStorePaths } from './DataStorePaths';
export { PaneAnimationInfo } from './PaneAnimationInfo';

// WASM-Compatible API exports for viz-client integration (Phase 3A)
// These functions match the C++ WASM API that viz-client expects
export * from './RuntimeWebModuleExports';
